<template>
  <div v-if="!consentGiven" class="fixed bottom-0 left-0 w-full p-4 z-50 shadow-lg bg-surface-100 dark:bg-surface-800 border-t border-surface-300 dark:border-surface-700">
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-sm text-surface-700 dark:text-surface-200">
      <span class="flex-1">
        This site uses cookies to enhance your experience and for analytics. By clicking “Accept”, you consent to the use of cookies.
      </span>
      <div class="flex gap-2">
        <Button label="Accept" @click="acceptCookies" />
        <Button label="Decline" severity="secondary" @click="declineCookies" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const consentGiven = ref(false);

onMounted(() => {
  const stored = localStorage.getItem('cookie_consent');
  if (stored === 'accepted') {
    consentGiven.value = true;
    enableGA();
  } else if (stored === 'declined') {
    consentGiven.value = true;
  }
});

function acceptCookies() {
  localStorage.setItem('cookie_consent', 'accepted');
  enableGA();
  consentGiven.value = true;
}

function declineCookies() {
  localStorage.setItem('cookie_consent', 'declined');
  consentGiven.value = true;
}

function enableGA() {
  if (typeof gtag === 'function') {
    gtag('consent', 'update', {
      analytics_storage: 'granted'
    });
  }
}
</script>
